import {useSelector} from 'react-redux';
import SimpleLoader from '@frontend/ui-kit/Components/Loader';
import {getLoaderStatus} from '../../../slices/shared';
import styles from './index.module.scss';

const Loader = () => {
    const isLoader = useSelector(getLoaderStatus);

    return <SimpleLoader className={styles.loader} isLoader={isLoader}/>;
};

export {Loader as TestableLoader};
export default Loader;
